import React from 'react';
import { COLORS, RADIUS, SIZES, TYPOGRAPHY } from './design-tokens';

const LeafWatermark = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 400 300"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    style={{ position: 'absolute', top: 0, left: 0, opacity: 0.06, pointerEvents: 'none' }}
  >
    <g fill="none" stroke={COLORS.card} strokeWidth="2">
      <path d="M -50 50 Q 100 80 200 30 T 450 60" />
      <path d="M -30 130 Q 80 160 180 110 T 430 140" />
      <path d="M -40 210 Q 90 240 190 190 T 440 220" />
      <ellipse cx="80" cy="100" rx="35" ry="70" transform="rotate(-20 80 100)" />
      <ellipse cx="180" cy="170" rx="40" ry="80" transform="rotate(15 180 170)" />
      <ellipse cx="300" cy="80" rx="30" ry="60" transform="rotate(-30 300 80)" />
      <line x1="80" y1="30" x2="80" y2="170" />
      <line x1="180" y1="90" x2="180" y2="250" />
      <line x1="300" y1="20" x2="300" y2="140" />
      <path d="M 50 50 L 110 100" />
      <path d="M 110 100 L 50 150" />
      <path d="M 250 70 L 310 120" />
      <path d="M 310 120 L 250 170" />
      <path d="M 150 200 L 210 250" />
      <path d="M 210 250 L 150 300" />
    </g>
  </svg>
);

const BudgetHeader = ({ company, project }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `${SIZES.leftColumnWidth} ${SIZES.rightColumnWidth}`,
        columnGap: SIZES.columnGap,
        height: SIZES.headerHeight,
        marginBottom: '6mm',
        flexShrink: 0,
        width: SIZES.pageContentWidth
      }}
    >
      <div
        style={{
          background: COLORS.primary,
          borderRadius: `${RADIUS.card} 0 0 ${RADIUS.card}`,
          position: 'relative',
          overflow: 'hidden',
          padding: '6mm',
          display: 'flex',
          alignItems: 'flex-end',
          flexShrink: 0,
          width: SIZES.leftColumnWidth,
          height: SIZES.headerHeight
        }}
      >
        <LeafWatermark />
        <div style={{ position: 'relative', zIndex: 1, color: COLORS.card }}>
          <div style={{ fontSize: '10px', fontWeight: 600, opacity: 0.85, letterSpacing: '2px', marginBottom: '4px' }}>
            {(company && company.tagline) || 'MÓVEIS PLANEJADOS'}
          </div>
          <div style={{ fontSize: '18px', fontWeight: 700, letterSpacing: '0.5px' }}>
            {(company && company.name) || 'Sua Marca'}
          </div>
        </div>
      </div>

      <div
        style={{
          background: COLORS.card,
          borderRadius: `0 ${RADIUS.card} ${RADIUS.card} 0`,
          padding: '6mm 5mm',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          border: `1px solid ${COLORS.line}`,
          borderLeft: 'none',
          flexShrink: 0,
          width: SIZES.rightColumnWidth,
          height: SIZES.headerHeight,
          boxSizing: 'border-box'
        }}
      >
        <div style={{ marginBottom: '5mm' }}>
          <div style={{ ...TYPOGRAPHY.title, color: COLORS.primary }}>
            ORÇAMENTO
          </div>
          <div style={{ ...TYPOGRAPHY.subtitle, color: COLORS.primaryDark, marginTop: '1mm' }}>
            Personalizado
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '20mm 1fr',
            rowGap: '1.5mm',
            columnGap: '2mm',
            alignItems: 'center'
          }}
        >
          <span style={{ ...TYPOGRAPHY.label, color: COLORS.textSecondary }}>DATA:</span>
          <span
            style={{
              borderBottom: `1px solid ${COLORS.line}`,
              fontSize: '11px',
              color: COLORS.textPrimary,
              paddingBottom: '1px',
              minHeight: '4mm'
            }}
          >
            {project && project.date ? project.date : ' '}
          </span>
          <span style={{ ...TYPOGRAPHY.label, color: COLORS.textSecondary }}>VALIDADE:</span>
          <span
            style={{
              borderBottom: `1px solid ${COLORS.line}`,
              fontSize: '11px',
              color: COLORS.textPrimary,
              paddingBottom: '1px',
              minHeight: '4mm'
            }}
          >
            {project && project.validity ? project.validity : ' '}
          </span>
          <span style={{ ...TYPOGRAPHY.label, color: COLORS.textSecondary }}>Nº DO PROJETO:</span>
          <span
            style={{
              borderBottom: `1px solid ${COLORS.line}`,
              fontSize: '11px',
              color: COLORS.textPrimary,
              paddingBottom: '1px',
              minHeight: '4mm'
            }}
          >
            {project && project.number ? project.number : ' '}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BudgetHeader;
